// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e3afbc1b","732":"a79ec993","977":"055c1345"}[chunkId] + ".chunk.js";
};